import { render, staticRenderFns } from "./LoadingListAvatarTwoLines.vue?vue&type=template&id=d6c40b82"
import script from "./LoadingListAvatarTwoLines.vue?vue&type=script&lang=ts"
export * from "./LoadingListAvatarTwoLines.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6c40b82')) {
      api.createRecord('d6c40b82', component.options)
    } else {
      api.reload('d6c40b82', component.options)
    }
    module.hot.accept("./LoadingListAvatarTwoLines.vue?vue&type=template&id=d6c40b82", function () {
      api.rerender('d6c40b82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loading-templates/LoadingListAvatarTwoLines.vue"
export default component.exports